module.exports = __webpack_public_path__ + "img/715.d6c1aa00.jpg";